/*
 * @Author: 毛和水
 * @Date: 2024-04-24 21:11:12
 * @LastEditors: 毛和水
 * @LastEditTime: 2024-05-22 10:05:25
 * @Description: file content
 */
import type {
  IRequestOrderTemplateModel,
  IRequestOrderTemplateStore,
} from '@monorepo/types/orders/requestOrderTemplate/requestOrderTemplate.types';

const initState: IRequestOrderTemplateStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    page: 1,
    pageSize: 50,
    sort_order: 'UPDATED_DESC',
  },
};

const requestOrderTemplateModel: IRequestOrderTemplateModel = {
  namespace: 'requestOrderTemplate',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};

export default requestOrderTemplateModel;
